var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUiFilterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 26 21"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-23.5 -204)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 366",
  fill: "none",
  stroke: "#25358e",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.5 206.5h24"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 367",
  fill: "none",
  stroke: "#25358e",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.5 214.5h24"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 368",
  fill: "none",
  stroke: "#25358e",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.5 222.5h24"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 391",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(28 204)",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 392",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(39 212)",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 393",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(33 220)",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/UI-filter-icon.ba42c5ab7fc61d8449f024955e7368b1.svg";
export { SvgUiFilterIcon as ReactComponent };